import React from 'react';
import QuestionPanel from "../../structure/QuestionPanel";
import RadioGroup from "../../structure/RadioGroup";
import { useFormikContext } from "formik";
import { EmployeeFormValues } from "../../common/EmployeeFormValues";
import { PfmlEmployeeFormValues } from "../../pfml/PfmlEmployeeFormValues";
import StateDropdown from "../../input/StateDropdown";
import TextInput from "../../input/TextInput";

const ChildSupport = () => {
    const { values } = useFormikContext<EmployeeFormValues>();

    return (
        <QuestionPanel headerText={`Child Support`}
                       panelContent={
                           <div>
                               <RadioGroup id="child-support-paid"
                                           label="Are any child support obligations currently owed by you?"
                                           required={true} radioProps={[
                                   { id: "yes", text: "Yes" },
                                   { id: "no", text: "No" }
                               ]}/>
                               {(values as any as PfmlEmployeeFormValues)?.childSupportPaid === "Yes" &&
                                   <>
                                       <StateDropdown id="child-support-state" label={'State'} required={true}/>
                                       <TextInput id="child-support-county" label={'County'} required={true}/>
                                   </>}
                           </div>
                       }
        >
        </QuestionPanel>
    )
};
export default ChildSupport;